import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    IUserCountryDetails,
    TBuyboxEnabledData,
    TGoalsConfig,
} from "@ts/common-types";

const enableDaypartingSlice = createSlice({
    name: "enableDayparting",
    initialState: { value: false },
    reducers: {
        updateEnableDayparting: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const enableBuyboxSlice = createSlice({
    name: "enableBuybox",
    initialState: { value: false },
    reducers: {
        updateEnableBuybox: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const enableRevstackSlice = createSlice({
    name: "enableRevstack",
    initialState: { value: false },
    reducers: {
        updateEnableRevstack: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const enableKeywordRecommendationSlice = createSlice({
    name: "enableKeywordRecommendation",
    initialState: { value: false },
    reducers: {
        updateEnableKeywordRecommendation: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const clientTimezoneSlice = createSlice({
    name: "clientTimezone",
    initialState: { value: "" },
    reducers: {
        updateClientTimezone: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

const buyboxEnabledDataSlice = createSlice({
    name: "buyboxEnabledData",
    initialState: { value: [] },
    reducers: {
        updateBuyboxEnabledData: (
            state,
            action: PayloadAction<TBuyboxEnabledData>
        ) => {
            state.value = action.payload;
        },
    },
});

const isBuyboxUpdatedSlice = createSlice({
    name: "isBuyboxUpdated",
    initialState: { value: false },
    reducers: {
        updateIsBuyboxUpdated: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const focusedAsinsSlice = createSlice({
    name: "focusedAsins",
    initialState: { value: [] },
    reducers: {
        setFocusedAsins: (state, action: PayloadAction<string[]>) => {
            state.value = action.payload;
        },
    },
});

const doPreferredSellersExistSlice = createSlice({
    name: "doPreferredSellersExist",
    initialState: { value: false },
    reducers: {
        updateDoPreferredSellersExist: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const userCountryDetailsSlice = createSlice({
    name: "userCountryDetails",
    initialState: {
        value: {
            selected_country_code: "US",
            // country_name:"",
            selected_country_locale: [],
        },
    },
    reducers: {
        updateUserCountryDetails: (
            state,
            action: PayloadAction<IUserCountryDetails>
        ) => {
            state.value = action.payload;
        },
    },
});

const goalsConfigslice = createSlice({
    name: "goalsConfig",
    initialState: { value: [] },
    reducers: {
        setGoalsConfig: (state, action: PayloadAction<TGoalsConfig[]>) => {
            state.value = action.payload;
        },
    },
});

export const { updateEnableDayparting } = enableDaypartingSlice.actions;
export const { updateEnableBuybox } = enableBuyboxSlice.actions;
export const { updateEnableRevstack } = enableRevstackSlice.actions;
export const { updateEnableKeywordRecommendation } =
    enableKeywordRecommendationSlice.actions;
export const { updateIsBuyboxUpdated } = isBuyboxUpdatedSlice.actions;
export const { updateClientTimezone } = clientTimezoneSlice.actions;
export const { updateBuyboxEnabledData } = buyboxEnabledDataSlice.actions;
export const { updateDoPreferredSellersExist } =
    doPreferredSellersExistSlice.actions;
export const { updateUserCountryDetails } = userCountryDetailsSlice.actions;
export const { setFocusedAsins } = focusedAsinsSlice.actions;
export const { setGoalsConfig } = goalsConfigslice.actions;

export const enableDaypartingReducer = enableDaypartingSlice.reducer;
export const enableBuyboxReducer = enableBuyboxSlice.reducer;
export const enableRevstackReducer = enableRevstackSlice.reducer;
export const enableKeywordRecommendationReducer =
    enableKeywordRecommendationSlice.reducer;
export const clientTimezoneReducer = clientTimezoneSlice.reducer;
export const buyboxEnabledDataReducer = buyboxEnabledDataSlice.reducer;
export const isBuyboxUpdatedReducer = isBuyboxUpdatedSlice.reducer;
export const doPreferredSellersExistReducer =
    doPreferredSellersExistSlice.reducer;
export const userCountryDetailsReducer = userCountryDetailsSlice.reducer;
export const focusedAsinsReducer = focusedAsinsSlice.reducer;
export const goalsConfigReducer = goalsConfigslice.reducer;
